import React from 'react';
import styles from './EnrichmentProgramItem.module.scss';
import { eventMomentFactory } from '../../../../data/misc/eventMomentFactory';
import { TIME_FORMAT_SPAN } from '../../../../data/constants/datetime';

function EnrichmentProgramItem(props) {
    const { program } = props;

    if (!program) return null;

    const start = eventMomentFactory(null, program.start_local);

    return (
            <div className={styles.EnrichmentProgramItem}>
                {start.format(TIME_FORMAT_SPAN)} {program.name}
            </div>
    );
}

export default EnrichmentProgramItem;
